/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { store as sarsaparillaStore, sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth/redux';

import { externalRatingReviewsReducers } from 'ui-rating-review/src/reducers';
import permitReducers from '../src/reducers/permit';
import permitValidationReducers from '../src/reducers/permit-validation';

import { reducers as permitContentReducers } from '../shared-components/slices/permitContent';
import permitSharedReducers from '../shared-components/reducers';

import moduleStore from '../src/store';

const rootReducer = combineReducers({
    permit: permitReducers,
    permitShared: permitSharedReducers,
    permitContent: permitContentReducers,
    permitValidation: permitValidationReducers,
    ratingReviews: externalRatingReviewsReducers,
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
});

const initialState = {
    ...moduleStore(),
    ...sarsaparillaStore(),
};

export function setupStore(preloadedState?: any) {
    const store = configureStore({
        preloadedState,
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: ['launchdarkly', 'permit.result.rules'],
                },
                immutableCheck: {
                    ignoredPaths: ['permit', 'permitValidation.results'],
                },
            });
        },
        devTools: process.env.DEV_TOOLS_ENABLED,
    });

    return store;
}

const store = setupStore(initialState);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

export { rootReducer };

export default store;
